export enum ModuleTypes {
  disclaimerMessage = 'disclaimerMessage',
  patientList = 'patientList',
  podiatry = 'podiatry',
  nonPodiatry = 'nonPodiatry',
  existingPatient = 'existingPatient',
  medicalHistory = 'medicalHistory',
  consentForm = 'consentForm',
  genericMessage = 'genericMessage',
  pharmacyMedications = 'pharmacyMedications',
  appointmentConfirmation = 'appointmentConfirmation',
  communiqueByPatientInfo = 'communiqueByPatientInfo',
  tempo = 'tempo',
  rtmEnrollment = 'rtmEnrollment',
  rtmCheckIn = 'rtmCheckIn',
  completed = 'completed',
}
